import React from "react"
import tw, { styled } from "twin.macro"
import CompanyMapping from "../../content/blog/artificial-intelligence-ai-startups-synthetic-biology-synbio-venture-meta-review-analysis/cover/CompanyMapping.js"
import CategoryMapping from "../../content/blog/artificial-intelligence-ai-startups-synthetic-biology-synbio-venture-meta-review-analysis/cover/CategoryMapping.js"
import Logos from "../../content/blog/artificial-intelligence-ai-startups-synthetic-biology-synbio-venture-meta-review-analysis/cover/logosc5.inline.svg"
import HeadersLines from "../../content/blog/artificial-intelligence-ai-startups-synthetic-biology-synbio-venture-meta-review-analysis/cover/header_lines.inline.svg"
import TwConfig from "../../tailwind.config.js"

// dummy to ensure parent has height even though contents are absolute
const Dummy = styled.div`
  ${tw`
    z-0 
  `}
  padding-top: 52%;
`

// dummy to position the molecules
const DummyMolecules = styled.div`
  ${tw`
    z-0 
  `}
  padding-top: 10%;
`

// dummy empty company
const DummyCompany = {
  id: "",
  year: "",
  website: "",
  description: "",
  group: "",
}

// dummy empty catgeory
const DummyCategory = {
  id: "",
  rect_x: "",
  rect_y: "",
  width: "",
  height: "",
  companies: [],
  text_x: "1",
}

class SyntheticBiologyCover extends React.Component {
  // two-pass rendering:
  // https://github.com/gatsbyjs/gatsby/issues/17914
  constructor() {
    super()
    this.state = {
      current_company: DummyCompany,
      current_category: DummyCategory,
    }
  }

  componentDidMount() {
    const randomCategory =
      CategoryMapping[Math.floor(Math.random() * CategoryMapping.length)]

    const potentialCompanies = CompanyMapping.filter((obj) => {
      return randomCategory.companies.includes(obj.id)
    })

    this.setState({
      current_company:
        potentialCompanies[
          Math.floor(Math.random() * potentialCompanies.length)
        ],
      current_category: randomCategory,
    })
  }

  onCompanyClick(id) {
    const newCompany = CompanyMapping.filter((obj) => {
      return obj.id === id
    })[0]

    this.setState({
      current_company: newCompany,
      current_category: CategoryMapping.filter((obj) => {
        return obj.id === newCompany.group
      })[0],
    })

    console.log(
      "oncompanyclick - from: ",
      this.state.current_company.id,
      " to: ",
      newCompany.id
    )
  }

  onCategoryClick(id) {
    const newCategory = CategoryMapping.filter((obj) => {
      return obj.id === id
    })[0]

    const potentialCompanies = CompanyMapping.filter((obj) => {
      return newCategory.companies.includes(obj.id)
    })

    if (newCategory.id !== this.state.current_category.id) {
      this.setState({
        current_category: newCategory,
        current_company:
          potentialCompanies[
            Math.floor(Math.random() * potentialCompanies.length)
          ],
      })

      console.log(
        "oncategoryclick - from: ",
        this.state.current_category.id,
        " to: ",
        newCategory.id
      )
    }
  }

  changeFill(id, type) {
    if (id === this.state.current_category.id && type === "category") {
      return TwConfig.theme.extend.colors.nepal
    }
    if (type === "category") {
      return "transparent"
    }
    if (id === this.state.current_company.id && type === "company") {
      return TwConfig.theme.extend.colors.londonhue
    }
    if (type === "company") {
      return TwConfig.theme.extend.colors.darkgrey
    }
  }

  render() {
    const textTransform = `matrix(1 0 0 1 ${this.state.current_category.text_x} 294.8715)`
    const textTransformTest = `matrix(1 0 0 1 0 50)`
    return (
      // band
      <div className="w-full bg-mediumgrey mb-10">
        {/* container */}
        <div className="max-w-6xl mt-4 mb-4 mx-auto flex flex-wrap content-start justify-end p-2">
          {/* title row */}
          <div className="w-full lg:w-full p-2 pt-8 lg:pr-8">
            {/* title and date */}
            <div className="w-full ">{this.props.children}</div>
          </div>
          {/* graphic row */}

          <div className="w-full lg:w-full relative mt-2">
            {/* draws vertical blues */}
            {/* 680 is manually changed from 626.459 */}

            <svg
              className="absolute w-full h-auto"
              x="0px"
              y="0px"
              viewBox="455.779 -210.42 1158.908 680"
            >
              {CategoryMapping.map((category, index) => {
                return (
                  <rect
                    className="cursor-pointer"
                    key={index}
                    fill={this.changeFill(category.id, "category")}
                    onClick={() => this.onCategoryClick(category.id)}
                    x={category.rect_x}
                    y={category.rect_y}
                    width={category.width}
                    height={category.height}
                  />
                )
              })}
            </svg>

            {/* draws company grey/purple rects */}
            <svg
              className="absolute w-full h-auto z-20 pointer-events-none"
              x="0px"
              y="0px"
              viewBox="455.779 -210.42 1158.908 626.459"
            >
              {CompanyMapping.map((company, index) => {
                return (
                  <rect
                    className="pointer-events-auto cursor-pointer"
                    key={index}
                    fill={this.changeFill(company.id, "company")}
                    onClick={() => this.onCompanyClick(company.id)}
                    x={company.rect.x}
                    y={company.rect.y}
                    width={company.rect.width}
                    height={company.rect.height}
                  />
                )
              })}
            </svg>

            {/* draws company name, year, text through dangerously, and finally link to website */}
            <svg
              className="absolute w-full h-auto z-50 pointer-events-none font-sans"
              x="0px"
              y="0px"
              viewBox="455.779 -210.42 1158.908 800"
            >
              {/* company name */}
              <text transform={textTransform}>
                <tspan
                  x="0"
                  y="0"
                  fill="#424242"
                  fontWeight="600"
                  fontSize="16px"
                >
                  {this.state.current_company.id}
                </tspan>

                {/* company year */}
                <tspan
                  x="0"
                  y="14.2"
                  fill="#424242"
                  fontSize="11px"
                >
                  {this.state.current_company.year}
                </tspan>

                {/* company text */}
                <tspan
                  dx="0"
                  dangerouslySetInnerHTML={{
                    __html: `${this.state.current_company.description}`,
                  }}
                />
              </text>

              <a
                xlinkHref={this.state.current_company.website}
                target="_blank"
                className="pointer-events-auto cursor-pointer"
              >
                <text
                  x={this.state.current_category.text_x}
                  y="458"
                  className="text-xl"
                >
                  &#8599;&#xfe0e;
                </text>
              </a>
            </svg>

            <Logos className="absolute w-full h-auto z-30 pointer-events-none" />
            <HeadersLines className="absolute w-full h-auto z-30 pointer-events-none" />

            <DummyMolecules />

            {/* draws molecules stills and gifs */}
            <div className="absolute grid grid-cols-5 w-full pointer-events-none cursor-pointer">
              {CategoryMapping.map((category, index) => {
                return (
                  <div key={category.id || index} className="">
                    <img
                      src={
                        this.state.current_category.id == category.id
                          ? category.gif
                          : category.still
                      }
                      className="w-full"
                    />
                  </div>
                )
              })}
            </div>

            <Dummy />
          </div>
        </div>
      </div>
    )
  }
}

export default SyntheticBiologyCover
